<template>
  <CardFrame :bgColor="data.backgroundColor" :hasDropShadow="false">
    <CardContainer>
      <CardHeaderContainer>
        <Title class="text-left" :headingTag="'h3'" :style="'h3'">
          {{ data.title }}
        </Title>
      </CardHeaderContainer>
      <CardBodyContainer>
        <List class="pl-20px" :items="data.list"></List>
      </CardBodyContainer>
      <CardButtons :buttons="data.buttons"></CardButtons>
    </CardContainer>
  </CardFrame>
</template>

<script>
import CardContainer from "../../Atoms/Cards/CardContainer.vue";
import CardHeaderContainer from "../../Atoms/Cards/CardHeaderContainer.vue";
import CardBodyContainer from "../../Atoms/Cards/CardBodyContainer.vue";
import CardButtons from "../../Atoms/Cards/CardButtons.vue";
import CardFrame from "../../Atoms/Cards/CardFrame.vue";
import List from "../../Atoms/List.vue";
import Title from "../../Atoms/Heading.vue";

export default {
  components: {
    CardBodyContainer,
    CardButtons,
    CardContainer,
    CardHeaderContainer,
    CardFrame,
    List,
    Title,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
